// graphqlClient.js
import { phErrorCaught } from '../utils/posthogEvents';

const APPSYNC_URL = process.env.REACT_APP_APPSYNC_API_URL;

export async function graphqlRequest({ query, variables }) {
  const idToken = localStorage.getItem('id_token');

  if (!idToken) {
    console.warn('[graphqlRequest] No id_token in localStorage');
    const error = new Error('User is not authenticated');
    error.name = 'NoValidAuthTokens';
    throw error;
  }

  const res = await fetch(APPSYNC_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: idToken,
    },
    body: JSON.stringify({
      query,
      variables: variables || {},
    }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    console.error('[graphqlRequest] HTTP error', res.status, text);
    const httpError = new Error(`GraphQL HTTP error ${res.status}`);
    phErrorCaught(httpError, { source: 'graphql_request', status: res.status });
    throw httpError;
  }

  const data = await res.json();
  if (data.errors) {
    console.error('[graphqlRequest] GraphQL errors:', data.errors);
    const messages = data.errors.map((e) => e.message).join('\n');
    const err = new Error(messages);
    err.errors = data.errors;
    phErrorCaught(err, { source: 'graphql_response_errors' });
    throw err;
  }

  return data;
}
